// extracted by mini-css-extract-plugin
export default {"dialogTitle":"baseModal_dialogTitle__paxU3","btnPadding":"baseModal_btnPadding__Zrkrc","divider":"baseModal_divider__BjRlI","error":"baseModal_error__7rtgz"};